import { $, _, Backbone, Radio } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";
import InboomaBaseCollectionView from "../InboomaBaseCollectionView";
import { Notification } from "../../utils";

import Contingents from "../../collections/Contingents";

import AppointmentsCalendarItemViewTpl from "../../templates/appointments/AppointmentsCalendarItemViewTpl.html";

const CalendarItemView = InboomaBaseView.extend({
  template: AppointmentsCalendarItemViewTpl,
  className: "calendar-contingent-item",

  events: {
    "click .calendar-title": "_toggleCalendar",
    "click .remove-contingent": "_removeContingentFromCalendar",
  },

  _toggleCalendar() {
    $(".calendar-contingent-item.active").removeClass("active");
    this.$el.addClass("active");
    Backbone.history.navigate("appointments/" + this.model.get("id"), { trigger: true });
  },

  templateContext() {
    return {
      _: _,
      globalContingents: this.options.contingents.where({ resourcetype_id: 4 }),
    };
  },

  _removeContingentFromCalendar(el) {
    const contingent_id = Number(
      $(el.currentTarget).closest(".accordion-item").attr("data-inb-contingent"),
    );

    if (confirm(this.t("really_remove")) && typeof contingent_id != "undefined") {
      const that = this,
        contingent = this.model.get("contingents").get(contingent_id),
        _events = this.model.get("events");

      delete this.model.attributes.events;
      delete this.model.attributes.valid_from;
      delete this.model.attributes.created;

      this.model.get("contingents").remove(contingent);
      this.model.save(null, {
        success(model, response) {
          model.set("events", _events);
          model.set("contingents", new Contingents(model.get("contingents")));

          new Notification({
            message: that.t("removed_${a}", { a: that.t("contingent") }, "capital"),
            duration: 5000,
            closeable: true,
            icon: "fi fi-trash",
          });

          that.render();
        },
        error(model) {
          new Notification({
            message: that.t("request_error"),
            duration: 5000,
            closeable: true,
            icon: "fi fi-x",
          });
        },
      });
    }
  },

  onRender() {
    const that = this;

    if (this.options.active_calendar === this.model.get("id")) {
      this.$el.addClass("active");
    }

    // addContingentToCalendar event
    this.$el.find("select.link-contingent-select").on("change", (e) => {
      // Create patch request manually to lower risks
      const val = Number(e.currentTarget.value);

      if (typeof val != "undefined" && val != "" && val != NaN) {
        const _events = that.model.get("events");

        // Flush unnecessary calendar attributes
        // as API is very strict here
        delete that.model.attributes.events;
        delete that.model.attributes.valid_from;
        delete that.model.attributes.created;
        delete that.model.attributes.created_by;
        delete that.model.attributes.deleted;
        delete that.model.attributes.modified;
        delete that.model.attributes.modified_by;

        that.model.get("contingents").add(that.options.contingents.findWhere({ id: val }).toJSON());

        _.each(that.model.get("contingents").models, (contingent, key) => {
          if (typeof contingent == "undefined") return;

          // remove unnecessary attributes that'd disturb the api
          const _contingent = {
            id: contingent.get("id"),
            name: contingent.get("name"),
          };
          contingent.clear();
          contingent.set(_contingent);
        });

        that.model.save(null, {
          patch: true,
          success: (model, response) => {
            model.set("events", _events);
            model.set("contingents", new Contingents(model.get("contingents")));

            new Notification({
              message: that.t("added_${a}", { a: that.t("contingent") }, "capital"),
              duration: 5000,
              closeable: true,
              icon: "fi fi-calendar",
            });

            that.render();
          },
          error: (model, response) => {
            model.set("events", _events);
            console.log("f", model, response);
            that.render();
          },
        });
      }
    });
  },
});

export default InboomaBaseCollectionView.extend({
  childView: CalendarItemView,
  template: _.noop,
  el: "#inb-c-main-calendars__items",

  childViewOptions() {
    return {
      contingents: this._contingents,
      active_calendar: this.options.active_calendar,
    };
  },

  initialize() {
    // InboomaBaseCollectionView.prototype.initialize.apply(this);
    this._contingents = Radio.channel("contingents").request("get:data");
    this.render();
  },
});
